"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.consolidateTrackedApplications = void 0;
/**
 * Sum time worked for applications that have the same bundleId and
 * isDistraction. There should only be one of each application in the
 * list with the same bundleId and isDistraction.
 */
var consolidateTrackedApplications = function (apps) {
    return apps.reduce(function (result, app) {
        var existing = result.find(function (_a) {
            var bundleIdOrUrl = _a.bundleIdOrUrl, isDistraction = _a.isDistraction;
            return app.bundleIdOrUrl === bundleIdOrUrl &&
                app.isDistraction === isDistraction;
        });
        if (existing) {
            existing.timeWorked += app.timeWorked;
            return result;
        }
        return result.concat(__assign({}, app));
    }, []);
};
exports.consolidateTrackedApplications = consolidateTrackedApplications;
